// extracted by mini-css-extract-plugin
module.exports = {"VersionHeader":"TVChartContainerDweb_VersionHeader__W3ULf","TVChartContainer":"TVChartContainerDweb_TVChartContainer__gI_vb"};